export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 120 },
  // { key: '2', headerName: 'Zone Code', field: 'id', hide: false, width: 200 },
  { key: '3', headerName: 'Zone', field: 'zonal_name', hide: false, width: 260 },
  { key: '4', headerName: 'State', field: 'state_name', hide: false, width: 260 },
  { key: '5', headerName: 'Status', field: 'status', hide: false, width: 450 },
];
